var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{staticClass:"categories-offers",attrs:{"title":"Все счета","settings-title":"Все счета","error-text":"Счета не загружены","columns":_vm.columns,"filters":_vm.filters,"create-form":_vm.createForm,"table-options":_vm.invoicesTable}})
}
var staticRenderFns = []

export { render, staticRenderFns }